import React from "react";
import { Card } from "@/components/ui/card";
import { useLang } from "@/context/LanguageContext";
import { Phone, Shield, MapPin, Award, MessageCircle } from "lucide-react";

export default function About() {
  const { t } = useLang();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-10">
        <div className="overline text-secondary">About</div>
        <div className="wordmark text-6xl sm:text-7xl text-primary mt-2">
          Bhu<span className="wordmark-dot"></span><span className="wordmark-mitra">mitra</span>
        </div>
        <p className="text-sm text-muted-foreground mt-3 wordmark-devanagari text-lg">भूमित्र • ज़मीन का सच्चा साथी</p>
        <p className="text-base text-muted-foreground mt-4 max-w-2xl mx-auto leading-relaxed">
          BhoomiMitra Bharat ka trusted property marketplace hai — jahan har koi apni jamin, plot, ghar, ya shop
          seedha ownership ke saath list kar sakta hai, aur khareedaar ko poori transparency milti hai —
          3D view, verified papers, aur exact map location ke saath.
        </p>
      </div>

      <Card className="p-6 sm:p-8 mb-6" data-testid="contact-card">
        <div className="overline text-primary mb-4">Contact Us</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <a href="tel:+917014965172" className="flex gap-4 group" data-testid="contact-phone">
            <div className="w-12 h-12 rounded-full bg-primary/10 grid place-items-center shrink-0 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
              <Phone size={20} />
            </div>
            <div>
              <div className="overline text-secondary text-[10px]">Call</div>
              <div className="text-xl font-semibold tracking-tight mt-0.5 group-hover:text-primary">+91 70149 65172</div>
              <div className="text-xs text-muted-foreground mt-1">Sales & support</div>
            </div>
          </a>
          <a href="https://wa.me/917014965172" target="_blank" rel="noreferrer" className="flex gap-4 group" data-testid="contact-whatsapp">
            <div className="w-12 h-12 rounded-full bg-secondary/10 grid place-items-center shrink-0 group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors">
              <MessageCircle size={20} />
            </div>
            <div>
              <div className="overline text-secondary text-[10px]">WhatsApp</div>
              <div className="text-xl font-semibold tracking-tight mt-0.5 group-hover:text-secondary">+91 70149 65172</div>
              <div className="text-xs text-muted-foreground mt-1">Quick response 9AM-9PM</div>
            </div>
          </a>
        </div>
      </Card>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Card className="p-5">
          <Shield size={20} className="text-primary mb-2" />
          <div className="font-semibold">Verified Papers</div>
          <p className="text-xs text-muted-foreground mt-1">View-only papers with watermark. No downloads, no screenshots.</p>
        </Card>
        <Card className="p-5">
          <MapPin size={20} className="text-secondary mb-2" />
          <div className="font-semibold">Precise Location</div>
          <p className="text-xs text-muted-foreground mt-1">Every listing pinned to exact latitude / longitude on the map.</p>
        </Card>
        <Card className="p-5">
          <Award size={20} className="text-primary mb-2" />
          <div className="font-semibold">10-Day Free Trial</div>
          <p className="text-xs text-muted-foreground mt-1">Try full access free for 10 days. Simple monthly / 6-month / yearly plans. No brokerage. No hidden charges.</p>
        </Card>
      </div>

      <p className="text-center text-xs text-muted-foreground mt-10">
        © {new Date().getFullYear()} BhoomiMitra — A property venture proudly run from Bharat. All rights reserved.
      </p>
    </div>
  );
}
